import { render, staticRenderFns } from "./QuestionnaireView.vue?vue&type=template&id=0444dcb9"
import script from "./QuestionnaireView.vue?vue&type=script&lang=js"
export * from "./QuestionnaireView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports